const baseURLs: Record<string, string> = {
  DEV: 'https://dev.attachments.missioncontrol.nonprod-asurion53.com/public',
  UAT: 'https://attachments.missioncontrol.nonprod-asurion53.com/public',
  PROD: 'https://attachments.missioncontrol.asurion53.com/public',
  LOCAL: 'https://dev.attachments.missioncontrol.nonprod-asurion53.com/public',
}

export { baseURLs }
